import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <h3 className="footer-title">Toyota Lanka</h3>
          <p className="footer-description">
            Employee Intranet Portal
          </p>
        </div>

        <div className="footer-section">
          <h4 className="footer-heading">Quick Links</h4>
          <ul className="footer-links">
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/documents">Documents</Link>
            </li>
            <li>
              <Link to="/profile">Profile</Link>
            </li>
          </ul>
        </div>

        {/* <div className="footer-section">
          <h4 className="footer-heading">Support</h4>
          <ul className="footer-links">
            <li>
              <a href="mailto:support@toyotalanka.lk">Contact Support</a>
            </li>
            <li>
              <a href="tel:+94112345678">Help Desk</a>
            </li>
          </ul>
        </div> */}

        {/* <div className="footer-section">
          <h4 className="footer-heading">Company</h4>
          <ul className="footer-links">
            <li>
              <a href="#" onClick={(e) => e.preventDefault()}>About Us</a>
            </li>
            <li>
              <a href="#" onClick={(e) => e.preventDefault()}>Privacy Policy</a>
            </li>
            <li>
              <a href="#" onClick={(e) => e.preventDefault()}>Terms of Service</a>
            </li>
          </ul>
        </div> */}

        {/* <div className="footer-section">
          <h4 className="footer-heading">Departments</h4>
          <ul className="footer-links footer-links-departments">
            <li>
              <Link to="/departments/hr">HR</Link>
            </li>
            <li>
              <Link to="/departments/it">IT</Link>
            </li>
            <li>
              <Link to="/departments/finance">Finance</Link>
            </li>
            <li>
              <Link to="/departments/sales">Sales</Link>
            </li>
            <li>
              <Link to="/departments/service">Service</Link>
            </li>
            <li>
              <Link to="/departments/marketing">Marketing</Link>
            </li>
            <li>
              <Link to="/departments/admin">Admin</Link>
            </li>
            <li>
              <Link to="/departments/spareparts">Spare Parts</Link>
            </li>
          </ul>
        </div> */}
      </div>

      <div className="footer-bottom">
        <p className="footer-attribution">
          Developed and Maintained by VCMS Department
        </p>
        <p>&copy; {currentYear} Toyota Lanka (Pvt) Ltd. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;


